(() => {
  const containsPresale = (value) => String(value || '').toLowerCase().includes('pre-sale');

  const isPresaleVariant = (productInfo, variant) => {
    const selectedOptionValues = Array.from(
      productInfo.querySelectorAll('variant-selects select, variant-selects fieldset input:checked'),
    ).map((input) => (input.tagName === 'SELECT' ? input.selectedOptions[0]?.textContent : input.value));
    const selectedOptionLabels = Array.from(
      productInfo.querySelectorAll('variant-selects [data-selected-swatch-value]'),
    ).map((element) => element.textContent);

    return [variant?.title, ...(variant?.options || []), ...selectedOptionValues, ...selectedOptionLabels].some(
      containsPresale,
    );
  };

  const updatePresaleBlocks = (productInfo, variant) => {
    const showPresaleContent = isPresaleVariant(productInfo, variant);

    productInfo.querySelectorAll('[data-presale-information]').forEach((block) => {
      block.classList.toggle('hidden', !showPresaleContent);
    });

    productInfo.querySelectorAll('[data-presale-delivery-time]').forEach((block) => {
      const requiresPresaleVariant = block.dataset.presaleVariantRequired === 'true';
      const useCustomDeliveryTime =
        block.dataset.presaleInformationAvailable === 'true' &&
        block.dataset.presaleCustomDeliveryTimeAvailable === 'true' &&
        (!requiresPresaleVariant || showPresaleContent);

      block.querySelectorAll('[data-presale-delivery-time-custom]').forEach((element) => {
        element.classList.toggle('hidden', !useCustomDeliveryTime);
      });
      block.querySelectorAll('[data-presale-delivery-time-default]').forEach((element) => {
        element.classList.toggle('hidden', useCustomDeliveryTime);
      });
    });
  };

  const initializePresaleBlocks = () => {
    document.querySelectorAll('product-info').forEach((productInfo) => {
      updatePresaleBlocks(productInfo);
    });

    document.addEventListener('change', (event) => {
      const productInfo = event.target.closest('product-info');
      if (!productInfo || !event.target.closest('variant-selects')) return;

      window.setTimeout(() => updatePresaleBlocks(productInfo), 0);
    });

    if (!window.FoxTheme?.pubsub) return;

    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, ({ data }) => {
      document.querySelectorAll('product-info').forEach((productInfo) => {
        const sectionId = productInfo.dataset.originalSection || productInfo.dataset.section;
        if (String(sectionId) === String(data.sectionId)) {
          updatePresaleBlocks(productInfo, data.variant);
        }
      });
    });

  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePresaleBlocks, { once: true });
  } else {
    initializePresaleBlocks();
  }
})();
